import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useGlobalModalContext from '../../hooks/useGlobalModalContext';
import ProgressBackdrop from '../../preorder/components/ProgressBackdrop';
import { authActionType, useAuthDispatch } from '../../preorder/plugins/Auth';
import {
  getUserProfile, lineAuth, register,
} from '../api/auth';

const authMethodsDict = {
  line: lineAuth,
};

const ConnectThridPartyAccount = () => {
  const location = useLocation();
  const history = useHistory();
  const authDispatch = useAuthDispatch();
  const { openModal } = useGlobalModalContext();

  useEffect(() => {
    const doSomething = async () => {
      try {
        const { state } = location;
        const {
          mgmCampaign,
          referrerCustomerId,
          thirdPartyName,
          token: phoneAuthToken,
          from,
          day,
          gender,
          email,
          month,
          year,
          providerId,
        } = state || {};

        if (!Object.keys(authMethodsDict).includes(thirdPartyName)) {
          throw new Error(`the third-party ${thirdPartyName} is not support`);
        }

        const {
          status: thirdPartyAuthStatus,
          data: thirdPartyAuthData,
        } = await authMethodsDict[thirdPartyName](location.state);

        if (thirdPartyAuthStatus !== 'success') {
          throw new Error(`connect ${thirdPartyName} account fail`);
        }

        const { token: thirdPartyAuthToken } = thirdPartyAuthData;

        if (!thirdPartyAuthToken) throw new Error(`third-party ${thirdPartyName} auth faile`);

        const {
          status: registerStatus,
          data: registerData,
        } = await register(
          phoneAuthToken,
          thirdPartyAuthToken,
          referrerCustomerId,
          mgmCampaign,
          from,
          [year, month, day],
          gender,
          email,
          providerId
        );

        if (registerStatus !== 'success') throw new Error('register fail');

        const { token: registerAuthToken } = registerData;

        if (!registerAuthToken) throw new Error('register fail');

        const {
          data: profile,
          status: getUserProfileStatus,
        } = await getUserProfile(registerAuthToken);

        if (getUserProfileStatus !== 'success') throw new Error('get user profile fail');

        authDispatch({
          type: authActionType.LOGIN_SUCCESS,
          payload: {
            token: registerAuthToken,
            user: {
              ...profile,
            },
          },
        });

        history.push('/register', {
          isFinishRegister: true,
          ...state,
        });
      } catch (e) {
        console.log(e.message);

        openModal({
          title: '連結帳號失敗',
          content: '連結帳號失敗，請連繫客服人員',
        });

        history.push('/');
      }
    };
    doSomething();
  }, [location, history, authDispatch, openModal]);

  return <ProgressBackdrop isShow />;
};

export default ConnectThridPartyAccount;
